import ChecklistChanges from "features/CenterContent/RoleContent/VehicleChecklist/ChecklistChanges";
import { HistoryFillOut } from "features/CenterContent/RoleContent/VehicleChecklist/schema/responseSchema";
import {
  formatDate,
  formatTime,
} from "features/CenterContent/RoleContent/VehicleChecklist/utils";
import React from "react";
import { Box, Grid, Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

const gridProps = {
  templateColumns: "repeat(7, 1fr)",
  marginBottom: "1rem",
  marginTop: "1rem",
  gap: "1",
};

type ChecklistHistoryEntryProps = {
  currentEntry: HistoryFillOut;
  previousEntry: HistoryFillOut;
  index: number;
};

const ChecklistHistoryEntry: React.FC<ChecklistHistoryEntryProps> = ({
  currentEntry,
  previousEntry,
  index,
}) => {
  const theme = useTheme();

  return (
    <Grid {...gridProps}>
      {(index !== 0 || previousEntry.comment) && (
        <Box
          gridColumn="2 / 8"
          borderBottom={`1px solid ${theme.colorOutlineSecondary}`}
          mb="24px"
        />
      )}

      <Box gridColumn="2">
        <Text fontWeight="bold">{formatDate(currentEntry.changedAt)}</Text>
        <Text>{formatTime(currentEntry.changedAt)}</Text>
      </Box>

      {previousEntry && (
        <ChecklistChanges
          currentEntry={currentEntry}
          previousEntry={previousEntry}
        />
      )}

      <Text fontWeight="bold" gridColumn="2">
        Endret av:
      </Text>
      <Text gridColumn="3 / 7">{currentEntry.changedByName}</Text>

      {currentEntry.comment && (
        <>
          <Text fontWeight="bold" gridColumn="2" mt="6px">
            Kommentar:
          </Text>
          <Text gridColumn="3 / 7" mt="6px">
            {currentEntry.comment}
          </Text>
        </>
      )}
    </Grid>
  );
};

export default ChecklistHistoryEntry;
